import { render, staticRenderFns } from "./UnsavedChangesModalCmp.vue?vue&type=template&id=19de48cc&scoped=true&"
import script from "./UnsavedChangesModalCmp.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModalCmp.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesModalCmp.vue?vue&type=style&index=0&id=19de48cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de48cc",
  null
  
)

export default component.exports